import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../config/webpack/loaders/svg-sprite/sprite-runtime-with-turbolinks.js";
var symbol = new SpriteSymbol({
  "id": "icon__double-arrow-right",
  "use": "icon__double-arrow-right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon__double-arrow-right\"><path d=\"M22.218 12.545l-8.927 8.189a.742.742 0 0 1-1.051-.045.745.745 0 0 1 .046-1.052l8.329-7.64-8.329-7.641a.746.746 0 0 1 1.005-1.099l8.927 8.19a.743.743 0 0 1 0 1.098zm-9.284-.549a.747.747 0 0 1-.241.549l-8.927 8.189a.742.742 0 0 1-1.051-.045.745.745 0 0 1 .046-1.052l8.329-7.64-8.33-7.642a.744.744 0 0 1 1.005-1.098l8.927 8.19c.154.141.242.34.242.549z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol